"use client";

import { useCallback, useState } from "react";

import KundaliFormCard from "../_home/KundaliFormCard";
import TopicSelect, { clearConcernSelection, type ConcernSelection } from "./TopicSelect";
import { AI_ASTROLOGER_ONBOARDING_CONTRACT, AI_ASTROLOGER_TRUST_COPY } from "./onboarding-contract";
import styles from "./ConsultationHero.module.css";

export default function AIAstrologerConsultationIsland() {
  const [seoEntry, setSeoEntry] = useState<ConcernSelection | null>(null);
  const handleIntentCaptured = useCallback((entry: ConcernSelection) => {
    setSeoEntry(entry);
  }, []);

  // The concern picker is OPTIONAL refinement, NOT a gate: the chat-continuation
  // form (which generates the chart and opens the AI Jyotish chat) leads the first
  // useful viewport, matching the proven /free-kundali/ converter (rule 61 #2). The
  // old TopicSelect gate hid the form behind a concern tap, so only ~0.37% of
  // /ai-astrologer/ landers (3,226/day) ever reached an offer. When a concern IS
  // picked it still seeds the greeting via seoEntryOverride; when it isn't,
  // KundaliFormCard resolves the generic entry (useResolvedSEOEntry), so no concern
  // is required to proceed. Mandatory phone capture (rule 69) stays enforced by the
  // shared card; no offer is added to this chat-first surface (rules 39/40/46).
  return (
    <>
      {seoEntry ? (
        <div className={styles.selectedConcern}>
          <p>
            {seoEntry.topicTitle}
            <span>{seoEntry.topicLens}</span>
          </p>
          <button
            type="button"
            aria-label={AI_ASTROLOGER_ONBOARDING_CONTRACT.concerns.changeLabel}
            onClick={() => {
              clearConcernSelection();
              setSeoEntry(null);
            }}
            className={styles.changeButton}
          >
            Change
          </button>
        </div>
      ) : (
        <div className="mx-auto max-w-md">
          <TopicSelect onIntentCaptured={handleIntentCaptured} />
        </div>
      )}
      <KundaliFormCard
        source="ai_astrologer"
        submitLabel="Generate chart and start chat"
        loadingLabel="Opening your AI Jyotish chat..."
        loadingLabelHi="AI Jyotish chat khul raha hai..."
        reassuranceNote={AI_ASTROLOGER_TRUST_COPY.en.reassurance}
        reassuranceNoteHi={AI_ASTROLOGER_TRUST_COPY.hi.reassurance}
        phoneReason={AI_ASTROLOGER_TRUST_COPY.en.savedNote}
        phoneReasonHi={AI_ASTROLOGER_TRUST_COPY.hi.savedNote}
        showDailyInsightCard={false}
        containerClassName="mx-auto max-w-md"
        formClassName="space-y-5"
        placePlaceholder="City or birth place"
        seoEntryOverride={seoEntry ?? undefined}
        progressiveCopy={AI_ASTROLOGER_TRUST_COPY.progressive}
        showIntentBanner={false}
      />
    </>
  );
}
